import { render, staticRenderFns } from "./AlertasContenido.vue?vue&type=template&id=f461ff26&"
import script from "./AlertasContenido.vue?vue&type=script&lang=js&"
export * from "./AlertasContenido.vue?vue&type=script&lang=js&"
import style0 from "./AlertasContenido.vue?vue&type=style&index=0&id=f461ff26&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports